import {
  BLOG_01_IMG_02_857X480,
  BLOG_01_IMG_03_857X480,
  BLOG_01_IMG_04_857X480,
  BLOG_01_MAIN_IMAGE_857X480,
  BLOG_01_SHOWCASE_IMAGE_392X260,
  BLOG_02_IMG_02_857X480,
  BLOG_02_IMG_03_857X480,
  BLOG_02_IMG_04_857X480,
  BLOG_02_MAIN_IMAGE_857X480,
  BLOG_02_SHOWCASE_IMAGE_392X260,
  BLOG_AVATAR01,
} from "../lib/assets";

/** Structural blog data (locale-free). Copy lives in locales/{locale}/blogs.json */
export const BLOG_STRUCTURE = [
  {
    id: 1,
    src: BLOG_01_SHOWCASE_IMAGE_392X260,
    authorSrc: BLOG_AVATAR01,
    href: "/blog-details",
    tagHref: "/blog",
    content: {
      mainImage: BLOG_01_MAIN_IMAGE_857X480,
      images: [
        BLOG_01_IMG_02_857X480,
        BLOG_01_IMG_03_857X480,
        BLOG_01_IMG_04_857X480,
      ],
    },
  },
  {
    id: 2,
    src: BLOG_02_SHOWCASE_IMAGE_392X260,
    authorSrc: BLOG_AVATAR01,
    href: "/blog-details",
    tagHref: "/blog",
    content: {
      mainImage: BLOG_02_MAIN_IMAGE_857X480,
      images: [
        BLOG_02_IMG_02_857X480,
        BLOG_02_IMG_03_857X480,
        BLOG_02_IMG_04_857X480,
      ],
    },
  },
];

export const BLOG_TAGS_STRUCTURE = [
  {
    id: 1,
    href: "/blog",
  },
];

export const getBlogs = (t) =>
  BLOG_STRUCTURE.map((blog) => {
    const copy = t(`items.${blog.id}`, { ns: "blogs", returnObjects: true });
    if (!copy || typeof copy !== "object") {
      return blog;
    }
    const { content: contentCopy, ...rest } = copy;
    return {
      ...blog,
      ...rest,
      content: {
        ...blog.content,
        ...(contentCopy || {}),
      },
    };
  });

export const getBlogById = (t, id) => {
  if (id == null || id === "") {
    return undefined;
  }
  return getBlogs(t).find((blog) => blog.id === Number(id));
};

/** Locale-free details path including blog id in the query string. */
export const blogDetailsPath = (blogId) =>
  `/blog-details?blogId=${encodeURIComponent(blogId)}`;

export const getBlogTags = (t) =>
  BLOG_TAGS_STRUCTURE.map((tag) => {
    const copy = t(`tags.${tag.id}`, { ns: "blogs", returnObjects: true });
    return {
      ...tag,
      ...(copy && typeof copy === "object" ? copy : {}),
    };
  });

/** @deprecated Prefer getBlogs(t) */
export const BLOG_PAGE_LIST = BLOG_STRUCTURE;

/** @deprecated Prefer getBlogTags(t) */
export const BLOG_TAGS = BLOG_TAGS_STRUCTURE;
